module.exports = __webpack_public_path__ + "img/mobile-crusher.f72e318.png";